//import React from 'react';
import GenericIconButton from '../GenericComponents/GenericIconButton';
import styles from './BrowseMode.module.css';
import {  useCCContext } from '../CC/CCContext';

function BrowseMode() {
  const { cc, setCc, browseMode, setBrowseMode } = useCCContext();
  
  const changeModeToPaginate = () => {
    setBrowseMode('paginate');
    setCc(cc);
  }
  
  const changeModeToScroll = () => {
    setBrowseMode('scroll');
    setCc(cc);
  }
  return (
    <div className={styles.BrowseMode}>
      <GenericIconButton ariaLabel='Mode pagination' isActive={browseMode === 'paginate'} icon='light/book-open.svg' onClick={ () => changeModeToPaginate() }/>
      <GenericIconButton ariaLabel='Mode infini' isActive={browseMode === 'scroll'} icon='light/scroll.svg' onClick={ () => changeModeToScroll() }/>
    </div>
  );
}

export default BrowseMode;
